import React from "react";

// Cartão de uma seção das regras: ícone, título, explicação curta e o conteúdo.
export default function Bloco({ icone: Icone, titulo, subtitulo, direita, children, e2e, corIcone = "bg-purple-500/15 text-purple-500" }) {
  return (
    <section className="rounded-2xl border bg-card p-4 sm:p-5" data-e2e={e2e}>
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className={`w-9 h-9 rounded-xl ${corIcone} flex items-center justify-center shrink-0`}>
            <Icone className="w-[18px] h-[18px]" />
          </div>
          <div className="min-w-0">
            <h3 className="text-base font-bold leading-tight">{titulo}</h3>
            {subtitulo && <p className="text-xs text-muted-foreground mt-0.5 leading-snug">{subtitulo}</p>}
          </div>
        </div>
        {direita}
      </div>
      {children}
    </section>
  );
}
